import api from './api';

export type ListType = 'contacts' | 'companies' | 'both';

export interface GenerateGuideInput {
  listType: ListType;
  icpId?: string;
  personaId?: string;
  product?: string;
  context?: string;
}

export interface GuideStep {
  category: string;
  what: string;
  why: string;
  recommendation: string;
}

export interface ListBuildingGuide {
  listType: ListType;
  summary: string;
  steps: GuideStep[];
  signals: string[];
  titleVariations: string[];
  targetListSize: string;
  notes: string;
}

export interface GuideResult {
  guide: ListBuildingGuide | null;
  raw?: string;
  provider: string;
  model: string;
}

class ListBuildingService {
  async generateGuide(input: GenerateGuideInput): Promise<GuideResult> {
    const response = await api.post('/list-building/guide', input);
    return response.data;
  }
}

const listBuildingService = new ListBuildingService();
export default listBuildingService;
